export const extractElementFormError = (fields: any) => {
  return (
    (Object.values(fields)[0] as any[])?.[0]?.message ||
    "Sorry, looks like there are some errors detected, please try again."
  );
};
